import { getLocalSettings } from "utils/common";
import colors from "./colors.json";

const settings = getLocalSettings();
export const primary_style = {
  backgroundColor: settings?.theme ?? colors.title_color,
  color: colors.accent_color,
};
